import api from "./api";

const BASE_PATH = "/api/wo-tech-note";

// Staff read/add hit the dedicated wo:readTechNote / wo:addTechNote-gated /staff
// endpoints. The base endpoints stay open for the technician app, which reads
// and writes tech notes from the field without staff permissions.
const create = (data) => {
  return api.post(`${BASE_PATH}/staff`, data);
};

const findAll = (woId) => {
  return api.get(`${BASE_PATH}/staff`, {
    params: woId ? { woId } : undefined,
  });
};

// Editing an existing note stays on the shared PATCH (no wo:updateTechNote gate);
// the staff UI limits editing to the note's own author.
const update = (id, data) => {
  return api.patch(`${BASE_PATH}/${id}`, data);
};

const TechNoteService = {
  create,
  findAll,
  update,
};

export default TechNoteService;
